import { render, staticRenderFns } from "./brainsInfo.vue?vue&type=template&id=99a334b6&scoped=true&"
import script from "./brainsInfo.vue?vue&type=script&lang=js&"
export * from "./brainsInfo.vue?vue&type=script&lang=js&"
import style0 from "./brainsInfo.vue?vue&type=style&index=0&id=99a334b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a334b6",
  null
  
)

export default component.exports